window.ajax_call = function (url, requestType, requestData, dataType, isAsync, successFunction) {
    if (requestType == undefined || requestType === null) {
        requestType = 'post';
    }
    if (requestData == undefined || requestData === null) {
        requestData = '';
    }
    if (dataType == undefined || dataType === null) {
        dataType = 'json';
    }
    if (isAsync == undefined || isAsync === null) {
        isAsync = false;
    }
    if (successFunction === undefined) {
        successFunction = function (response) {
            ret = response;
        };
    }
    requestData =
        requestData +
            '&' +
            $("meta[name='csrf-name']").attr('content') +
            '=' +
            $("meta[name='csrf-hash']").attr('content');
    var ret = false;
    var table = $('.tablePagination:visible');
    if (table.find('tr').length === 1) {
        table.append($('<tr class="listItem" data-loading="true"><td align="center" colspan="100">Loading &hellip;</td></tr>'));
    }
    $.ajax({
        url: url,
        type: requestType,
        data: requestData,
        dataType: dataType,
        async: isAsync,
        success: successFunction,
        error: function (xhr, ajaxOptions, thrownError) { },
    });
    table.find('tr[data-loading="true"]').remove();
    return ret;
};
window.showOutput = function (response) {
    $('.myLoader').hide();
    // Error condition of ajax_call
    if (response === false) {
        return;
    }
    if (response.status.code === 200) {
        window.showData(response.data);
        return;
    }
};
window.showData = function (data) {
    $('.pageTitle').html(data.title);
    $('.paginationArea').html(data.pagination);
    $('.showing').html(data.showing);
    $('.listItem').remove();
    $('.pageTitle').html(data.title);
    var list = data.list;
    window.listAllData(list);
};
